import { ZfIcon, ZfPill } from '@zafire/react';
import { AlternateInvestmentStatus } from 'types';
import { getStatusLabel } from './privateBankingStatusLabels';

type PillConfig = {
  color: 'success' | 'info' | 'neutral' | 'warning';
  icon: string;
};

const STATUS_CONFIG: Record<AlternateInvestmentStatus, PillConfig> = {
  [AlternateInvestmentStatus.READY_FOR_CONFIGURATION]: {
    color: 'warning',
    icon: 'settings',
  },
  [AlternateInvestmentStatus.READY_FOR_DISTRIBUTION]: { color: 'info', icon: 'check_circle' },
  [AlternateInvestmentStatus.IN_ACTIVATION]: { color: 'info', icon: 'history' },
  [AlternateInvestmentStatus.ACTIVE]: { color: 'success', icon: 'check_circle' },
  [AlternateInvestmentStatus.CLOSING]: { color: 'success', icon: 'check_circle' },
  [AlternateInvestmentStatus.INACTIVE]: { color: 'neutral', icon: 'do_not_disturb_on' },
  [AlternateInvestmentStatus.WITHDRAWN]: { color: 'neutral', icon: 'do_not_disturb_on' },
};

interface StatusPillProps {
  status: string | undefined;
  clickable: boolean;
}

export function StatusPill({ status, clickable = false }: StatusPillProps) {
  if (!status) return null;

  const { color, icon } = STATUS_CONFIG[status as AlternateInvestmentStatus] ?? {
    color: 'neutral',
    icon: 'schedule',
  };

  return (
    <ZfPill
      variant="soft"
      color={color}
      clickable={clickable}
      id={`status-pill-${color}`}
      data-testid={`pill-${status}`}
      style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      <ZfIcon slot="leading" name={icon} size="medium" />
      {getStatusLabel(status)}
    </ZfPill>
  );
}
